import {
	type ClientExpenseListItemResponseDTO,
	ClientFinancialPlanExpenseNameEnum,
	type ClientIncomeDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export type FinanceChartDataPoint = {
	value: number;
	label: string;
};

export const mapIncomeToChartData = (
	income: ClientIncomeDetailResponseDTO,
): FinanceChartDataPoint => ({
	value: income.amount,
	label: income.name ?? "",
});

export const mapExpenseToChartData = (
	expense: ClientExpenseListItemResponseDTO,
	t: ReturnType<typeof useResource>["t"],
): FinanceChartDataPoint => ({
	value: expense.monthlyPayment,
	label:
		expense.name === ClientFinancialPlanExpenseNameEnum.Total
			? t(Resources.Finances.Expenses.Types[expense.type].title)
			: t(Resources.Finances.Expenses.Names[expense.name]),
});
